<template>
  <b-row
    align-h="start"
    no-gutters>
    <b-col md="auto">
      <b-navbar-brand href="#/">
        <img
          src="../../assets/arexo/revatech-new-logo.png"
          height="35"
          alt="">
      </b-navbar-brand>
    </b-col>
    <b-col md="auto">
      <b-navbar-nav>
        <b-nav-item
          v-if="hasContactsModuleAccess"
          :active="activeTab === 'contacts'"
          @click="navigateToContactsModule">
          {{ $t('page.title.contacts') }}
        </b-nav-item>
      </b-navbar-nav>
    </b-col>
    <b-col md="auto">
      <b-navbar-nav>
        <b-nav-item
          v-if="hasOffersModuleAccess"
          :active="activeTab === 'offers'"
          href="#/offers">
          {{ $t('page.title.offers') }}
        </b-nav-item>
      </b-navbar-nav>
    </b-col>
    <b-col md="auto">
      <b-navbar-nav>
        <b-nav-item
          v-if="hasTransportsModulePlanningAccess"
          :active="activeTab === 'plannings'"
          href="#/planning">
          {{ $t('page.title.plannings') }}
        </b-nav-item>
      </b-navbar-nav>
    </b-col>
    <b-col md="auto">
      <b-navbar-nav>
        <b-nav-item
          v-if="hasTreatmentsModuleAnalysesAccess"
          :active="activeTab === 'treatments'"
          @click="navigateToTreatmentsModule">
          {{ $t('page.title.treatments') }}
        </b-nav-item>
      </b-navbar-nav>
    </b-col>
    <b-col md="auto">
      <b-navbar-nav>
        <b-nav-item
          v-if="hasTreatmentsModuleAnalysesAccess"
          :active="activeTab === 'analyses'"
          href="#/analyses">
          {{ $t('page.title.analyses') }}
        </b-nav-item>
      </b-navbar-nav>
    </b-col>
    <b-col md="auto">
      <b-navbar-nav>
        <b-nav-item
          v-if="hasPreInvoicesModuleAccess"
          :active="activeTab === 'pre-invoices'"
          @click="navigateToPreInvoicesModule">
          {{ $t('page.title.pre-invoices') }}
        </b-nav-item>
      </b-navbar-nav>
    </b-col>
    <b-col md="auto">
      <b-navbar-nav>
        <b-nav-item
          v-if="hasInvoicesModuleAccess"
          :active="activeTab === 'invoices'"
          @click="navigateToInvoicesModule">
          {{ $t('page.title.invoices') }}
        </b-nav-item>
      </b-navbar-nav>
    </b-col>
    <b-col md="auto">
      <b-navbar-nav>
        <b-nav-item
          v-if="hasTreatmentsModuleAnalysesAccess"
          :active="activeTab === 'certificates'"
          href="#/certificates">
          {{ $t('page.title.certificates') }}
        </b-nav-item>
      </b-navbar-nav>
    </b-col>
  </b-row>
</template>

<script>
export default {
  props: {
    hasContactsModuleAccess: Boolean,
    activeTab: String,
    navigateToContactsModule:Function,
    hasOffersModuleAccess: Boolean,
    hasTransportsModulePlanningAccess: Boolean,
    hasTreatmentsModuleAnalysesAccess: Boolean,
    navigateToTreatmentsModule: Function,
    hasPreInvoicesModuleAccess: Boolean,
    navigateToPreInvoicesModule: Function,
    hasInvoicesModuleAccess: Boolean,
    navigateToInvoicesModule: Function
  }
};
</script>
